import { useMediaQuery } from '@mui/material';

import { TrapActivationHistoryMonitoring } from 'api/traps/types';
import { MediaBreakpoints } from 'hooks/Screen/useScreenSize';

interface TrapMonitoringHistoryExpandableProps {
  data: TrapActivationHistoryMonitoring;
}
const TrapMonitoringHistoryExpandable: React.FC<TrapMonitoringHistoryExpandableProps> = ({ data }) => {
  const tablet = useMediaQuery(MediaBreakpoints.tablet);
  const desktop = useMediaQuery(MediaBreakpoints.desktop);

  return (
    <div className="d-flex w-100 flex-column">
      {tablet && (
        <div className="d-flex flex-lg-row my-2">
          <div className="mx-3">
            <span className="me-1 fs-14 fw-bold">Battery</span>
            <div>{data.battery_percentage}%</div>
          </div>

          {desktop && (
            <div className="mx-3">
              <span className="me-1 fs-14 fw-bold">Token</span>
              <div>{data.msg_token}</div>
            </div>
          )}
        </div>
      )}

      {desktop && (
        <div className="d-flex flex-lg-row my-2">
          <div className="mx-3">
            <span className="me-1 fs-14 fw-bold">RSSI</span>
            <div>{data.rssi}</div>
          </div>
          <div className="mx-3">
            <span className="me-1 fs-14 fw-bold">SNR</span>
            <div>{data.snr}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrapMonitoringHistoryExpandable;
